import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IUser } from '../../../../authentication/interfaces/user.interface';
import { EditProfileService } from '../../../services/edit-profile.service';

@Component({
  standalone: false,
  selector: 'suvo-users-edit-names',
  templateUrl: './edit-names.component.html',
  styleUrls: ['./edit-names.component.scss'],
})
export class EditNamesComponent implements OnInit {
  @Input() user: IUser;

  editedUser: IUser;
  basicsForm: FormGroup;

  constructor(private readonly editProfileService: EditProfileService) {}

  ngOnInit() {
    this.editedUser = { ...this.user };
    this.initialiseBasicsForm();
  }

  onEntrySaved() {
    for (const key in this.basicsForm.controls) {
      this.editedUser[key] = this.basicsForm.controls[key].value;
    }
    this.editProfileService.patchUser(this.editedUser);
  }

  initialiseBasicsForm() {
    const nameValidators = [Validators.required, Validators.maxLength(20)];
    this.basicsForm = new FormGroup({
      firstName: new FormControl('', nameValidators),
      lastName: new FormControl('', nameValidators),

      gender: new FormControl('', [Validators.required]),
      ethnicity: new FormControl('', [Validators.required]),
      dateOfBirth: new FormControl(null, [Validators.required]),
    });

    this.setBasicsFormValues(this.editedUser);
  }

  setBasicsFormValues(user: IUser) {
    for (const key in this.basicsForm.controls) {
      user[key]
        ? this.basicsForm.controls[key].setValue(user[key])
        : this.basicsForm.removeControl(key);
    }
  }
}
